export default {
  quantities        : ['500', '1000', '3000'],
  part_number       : '',
  revision          : '',
  bom_line_items    : '',
  smt               : '',
  thru_hole         : '',
  qfn               : '',
  double_sided_smt  : '0',
  double_sided_tht  : '0',
  lead_free         : '0',
  class_3_inspection: '0',
  assembly_restrictions: !isManager,
};
